import { inject } from '@angular/core';
import { Observable, switchMap, take } from 'rxjs';
import { GetMyGamesResponse } from '@core-http';
import { MyGamesService, MyGamesStorage } from '../../../../infrastructure';

export class LoadMyGamesCommandHandler {
  private readonly myGamesService: MyGamesService = inject(MyGamesService);
  private readonly myGamesStorage: MyGamesStorage = inject(MyGamesStorage);

  load(): Observable<void> {
    return this.myGamesService.getMyGames().pipe(
      take(1),
      switchMap((dto: GetMyGamesResponse) => this.myGamesStorage.setContext(dto))
    );
  }
}
